module.exports = __webpack_public_path__ + "img/inspiration.4e65712d.jpeg";